import * as types from './mutation-types'

export const toggleSidebar = ({ commit }, opened) => commit(types.TOGGLE_SIDEBAR, opened)

export const toggleDevice = ({ commit }, device) => commit(types.TOGGLE_DEVICE, device)

export const setUser = ({ commit }, user) => { commit(types.AUTH, user) }

export const setCustomer = ({ commit }, customer) => { commit(types.CUSTOMER, customer) }

export const setTokenRecoveryPassword = ({ commit }, token) => { commit(types.RECOVERY_PASSWORD, token) }

export const expandMenu = ({ commit }, menuItem) => {
  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false
    commit(types.EXPAND_MENU, menuItem)
  }
}

export const switchEffect = ({ commit }, effectItem) => {
  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js